<template>
  <add-edit-port></add-edit-port>
</template>

<script>
import AddEditPort from "@/layouts/components/masters/ports/addedit-port.vue";
export default {
  components: {
    AddEditPort
  }
};
</script>